import React from 'react';

/**
 * The template footer listed "components" (Admin Dashboard, Courier App,
 * Farm App...) as unlinked text — two of those apps don't exist and the admin
 * panel isn't public — and carried four social icons that all pointed at "/".
 * The quick links here are the same real destinations the header uses.
 */
const STORE_URL = 'https://store.agrichub.co.za';
const APP_URL = 'https://play.google.com/store/apps/details?id=za.co.agrichub&hl=en_ZA';

export default class FooterOne extends React.Component {
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                <footer className="footer-one">
                    <div className="footer-one__bg" style={{backgroundImage: 'url('+publicUrl+'assets/images/shapes/footer-v1-shape3.png)'}}></div>
                    <div className="shape1 float-bob-y"><img src={publicUrl+"assets/images/shapes/footer-v1-shape1.png"} alt="" /></div>
                    <div className="shape2 float-bob-y"><img src={publicUrl+"assets/images/shapes/footer-v1-shape2.png"} alt="" /></div>
                    {/* Start Footer */}
                    <div className="footer">
                        <div className="container">
                            <div className="footer-one__right">
                                <div className="row justify-content-between">
                                    {/* Start Footer Brand */}
                                    <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp" data-wow-delay="0.1s">
                                        <div className="footer-one__right-single footer-one__brand mb50">
                                            <a href={STORE_URL} className="footer-one__brand-logo">
                                                <img src={publicUrl+"assets/images/resources/logo-2.png"} alt="AgricHub" />
                                            </a>
                                            <p>Fresh produce straight from local farmers to your door.</p>
                                            <a href={STORE_URL} className="thm-btn">Shop Now</a>
                                        </div>
                                    </div>
                                    {/* End Footer Brand */}

                                    {/* Start Footer Quick Links */}
                                    <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp" data-wow-delay="0.2s">
                                        <div className="footer-one__right-single mb50">
                                            <div className="title">
                                                <h2>Quick Links</h2>
                                            </div>
                                            <ul className="footer-one__right-single-list">
                                                <li><a href={STORE_URL}>Shop Online</a></li>
                                                <li><a href={STORE_URL + '/become-a-vendor'}>Become A Vendor</a></li>
                                                <li><a href={STORE_URL + '/vendor/login'}>Farmer Portal</a></li>
                                                <li><a href={APP_URL} target="_blank" rel="noopener noreferrer">Get The App</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* End Footer Quick Links */}

                                    {/* Start Footer Legal */}
                                    <div className="col-xl-2 col-lg-2 col-md-6 wow animated fadeInUp" data-wow-delay="0.3s">
                                        <div className="footer-one__right-single mb50">
                                            <div className="title">
                                                <h2>Legal</h2>
                                            </div>
                                            <ul className="footer-one__right-single-list">
                                                <li><a href={STORE_URL + '/page/terms-of-service'}>Terms Of Use</a></li>
                                                <li><a href={STORE_URL + '/page/privacy-policy'}>Privacy Policy</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* End Footer Legal */}

                                    {/* Start Footer Contact */}
                                    <div className="col-xl-4 col-lg-4 col-md-6 wow animated fadeInUp" data-wow-delay="0.4s">
                                        <div className="footer-one__right-single mb50">
                                            <div className="title">
                                                <h2>Contact</h2>
                                            </div>
                                            <ul className="footer-one__right-single-contact footer-one__contact-list">
                                                <li><a href="tel:+27767725684">(+27) 76 772 5684</a></li>
                                                <li><a href="mailto:contact@agrichub.co.za">contact@agrichub.co.za</a></li>
                                                <li><a href="mailto:info@agrichub.co.za">info@agrichub.co.za</a></li>
                                                <li><p>55B Thrush Trail Road, Birdswood, Richards Bay, 3900</p></li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* End Footer Contact */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer-one__bottom">
                        <div className="container">
                            <div className="bottom-inner">
                                <div className="copyright">
                                    <p>© {new Date().getFullYear()} AgricHub. All Rights Reserved.</p>
                                </div>

                                <ul className="footer-one__bottom-menu">
                                    <li>Thumbela Communications (Pty) Ltd</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
        )
    }
}
